// Success alert messages
export const GENERIC_SUCCESS_TITLE = "Success";
export const GENERIC_SUCCESS_MESSAGE = "Your request has been processed successfully.";

export const LOGIN_SUCCESS_MESSAGE = "You have successfully logged in.";

// Failed form messages
export const E_ENTER_EMAIL_ADDRESS = "Please enter a valid email address.";
export const E_ENTER_PASSWORD = "Please enter your password.";
export const E_FIELD_REQUIRED = "This field is required.";

// Failed alert messages
export const E_GENERIC_TITLE = "Failed";
export const E_GENERIC_MESSAGE = "An error occurred while processing your request. Please try again later.";

// s3 URLs
export const PINNACLE_LOGO_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/admin-assets/2025-07-23-1753273550065.png";
export const SIDEBAR_LOGO = "https://pinnacleassets.sgp1.digitaloceanspaces.com/admin-assets/2025-07-23-1753277110545.png";
export const NO_DATA_TO_DISPLAY_URL = "https://pinnacleassets.sgp1.digitaloceanspaces.com/admin-assets/2025-07-24-1753368012546.png";
export const NO_DATA_TO_DISPLAY_WITHOUT_TEXT = "https://pinnacleassets.sgp1.digitaloceanspaces.com/preboard-assets/2025-12-19-1766105584726.svg";
export const VIMEO_PLAYER_URL = "https://player.vimeo.com/video";
export const HOW_TO_GET_VIMEOID_TUTORIAL_GIF = "https://sgp1.digitaloceanspaces.com/pinnacleassets/admin-assets/2025-08-26-1756197317271.gif";
// keys
export const ADMIN_STORAGE_KEY = "pinnacleAdminStreamingV3AccessToken";
export const ADMIN_CURRENT_NAME = "pinnacleAdminStreamingV3AdminName";

// Logout
export const SUCCESSFULLY_LOGGED_OUT_MSG = "You have successfully logged out.";
export const CONFIRM_LOGOUT_MSG = "Are you sure you want to log out?";

export const DEFAULT_PAGE_LIMIT = 15;

// export const tinyEditorApiKey = 'sr8gha99ek0kb05xtzsxcrbenlp6vcsvf20fftq877i1bzzk';
export const tinyEditorApiKey = 'qvoiwk2jjhxxsigosxz3sgz6xxlby0jo9pcwj1uk5ythlquc';